export default __webpack_public_path__ + "static/ti_hovercar_block-8c843b7d08952758bbdc36345b50f655.svg";